import { style } from '@vanilla-extract/css';

export const columns = style({
  display: 'flex',
  flexDirection: 'row',
});

export const stack = style({
  '@media': {
    'only screen and (max-width:667px)': {
      width: '100%',
      flexDirection: 'column',
    },
  },
});
